function propValidator(prop, arr) {
  return arr.length && arr.indexOf(prop) !== -1;
}

export default propValidator;
